"use strict";

$(function () {
  /*
   * Viva Travel Website scripts.
   */

  /*------------------------------------*\
      Hover on “Everything But”
  \*------------------------------------*/

  // Only fire if it's NOT a touch device as it fires with touch gestures otherwise.
  if ($(window).width() > 1024) {
    $(".blog-post-item, .card-level-of-cover, .card-cover-type").hover(function () {
      // Mouse over
      $(this).siblings().stop().fadeTo(300, 0.6);
      $(this).parent().siblings().stop().fadeTo(300, 0.5);
    }, function () {
      // Mouse out
      $(this).siblings().stop().fadeTo(300, 1);
      $(this).parent().siblings().stop().fadeTo(300, 1);
    });
  }

  /*------------------------------------*\
      Bootstrap +/- accordion
  \*------------------------------------*/

  $(".collapse").on('show.bs.collapse', function () {
    $(this).prev(".card-header").find(".plus-minus").html('-');
  }).on('hide.bs.collapse', function () {
    $(this).prev(".card-header").find(".plus-minus").html('+');
  });

  /*------------------------------------*\
      Toggle responsive menu.
  \*------------------------------------*/

  $('.hamburger').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    $('.responsive-menu-contents').fadeToggle();
    $('.responsive-menu-overlay').fadeToggle();
    $('html').toggleClass('prevent-scroll');
  });

  /*------------------------------------*\
      PREVIOUS PAGE BUTTON
  \*------------------------------------*/

  $('.previous-page').on('click', function () {
    window.history.back();
  });

  /*------------------------------------*\
      READING TIME
  \*------------------------------------*/

  var copy = $(".article-body").text();
  var wordCount = copy.replace(/[^\w ]/g, "").split(/\s+/).length;
  var readingTimeInMinutes = Math.floor(wordCount / 200) + 1;
  if (readingTimeInMinutes == 1) {
    var readingTimeAsString = readingTimeInMinutes + " minute";
  } else {
    var readingTimeAsString = readingTimeInMinutes + " minutes";
  }
  $('#reading-time').html(readingTimeAsString);

  /*------------------------------------*\
      Smooth scroll anchor links.
  \*------------------------------------*/

  // Select all links with hashes
  $('#sidebar').find('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]').not('[href="#0"]').click(function (event) {
    // On-page links
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function () {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          }
          ;
        });
      }
    }
  });

  // Smooth scroll anchors for sticky navbar ONLY
  $('.banner-navbar-menu').on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 100
    }, 1000);
  });

  /*------------------------------------*\
      Sticky navbar banner.
  \*------------------------------------*/

  // Resize sticky banners width.
  function resizeStickyBanner() {
    if ($(window).width() < 1460) {
      // Set sticky navbar width
      var outerContainerWidth = $('body').outerWidth();
      var bannerNavbar = $('#banner-navbar');
      $(bannerNavbar).outerWidth('100%');
    } else {
      // Set sticky navbar width
      var outerContainerWidth = $('.main-container').outerWidth();
      var bannerNavbar = $('#banner-navbar');
      $(bannerNavbar).outerWidth(outerContainerWidth);
    }
  }
  if ($('#banner-navbar').length) {
    // Toggle fixed position banner.
    var waypoint = new Waypoint({
      element: document.getElementById('banner-navbar'),
      handler: function () {
        $('#banner-navbar').toggleClass('sticky');
      }
    });

    // Page load
    resizeStickyBanner();
  }

  /*------------------------------------*\
      COPY ARTICLE SHARE LINK
  \*------------------------------------*/

  var clipboard = new ClipboardJS('.copy-link');
  clipboard.on('success', function (e) {
    $.magnificPopup.open({
      items: {
        src: '#dialog-link-copied'
      },
      type: 'inline',
      modal: true,
      mainClass: 'my-mfp-slide-bottom',
      fixedContentPos: true
    });
    e.clearSelection();
  });

  // Common close button
  $('.close-copied').on('click', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
    $('.mfp-close').trigger('click');
  });

  /*------------------------------------*\
      SOCIAL SHARING NEWS ARTICLES
  \*------------------------------------*/

  // Common
  var pageURL = window.location.href;
  // console.log('pageurl is ' + pageURL);
  var documentTitle = document.title;

  // Twitter (Working)
  var twitterURL = 'https://twitter.com/share?text=' + documentTitle + '&amp;url=' + pageURL;
  // console.log('twitterURL is ' + twitterURL);

  $('.twitter').on('click', function () {
    window.open('https://twitter.com/share?text=' + documentTitle + '&amp;url=' + pageURL, 'Twitter-dialog', 'width=626,height=436');
    return false;
  });

  /*------------------------------------*\
      Swiper.js - swipe elements.
  \*------------------------------------*/

  var swiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    observer: true,
    observeParents: true,
    loopAdditionalSlides: 2,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  });
  function toggleDisplayMobileSwiper() {
    if ($(window).width() < 481) {
      $('.swiper-container').css('display', 'flex');
      $('.swiper-pagination').css('display', 'flex');
    } else {
      $('.swiper-container').css('display', 'none');
      $('.swiper-pagination').css('display', 'none');
    }
  }

  // Page load
  toggleDisplayMobileSwiper();

  /*------------------------------------*\
      Move footer image for mobile.
  \*------------------------------------*/

  function moveFooterLogo() {
    if ($(window).width() < 768) {
      $('footer').find('.viva-logo').prependTo($('.foo'));
    } else {
      $('footer').find('.viva-logo').appendTo($('.bottom-bar-wrapper'));
    }
  }

  // Page load
  moveFooterLogo();

  /*------------------------------------*\
      Global window resize events.
  \*------------------------------------*/

  var resizeTimer;
  $(window).on('resize', function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      resizeStickyBanner();
      enableStickySidebar();
      toggleDisplayMobileSwiper();
      moveFooterLogo();
    }, 50);
  });
});
//# sourceMappingURL=data:application/json;charset=utf8;base64,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
